// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1ZO4c","alertIcon":"ConfirmModal_alertIcon__1lLU8"};